(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1254],{

/***/ 62454:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/alternatives",
      function () {
        return __webpack_require__(8131);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_SignatureRegister__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71605);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Buttons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46687);
/* harmony import */ var _components_AppContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2208);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10447);
/* harmony import */ var _components_google_ads_Buttons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71631);
/* harmony import */ var react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69274);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56475);









const CtaOne = (param)=>{
    let { heading1 , heading2 , heading3 , paragraph , paragraphStyling , buttonsStyling , buttonPrimaryText , buttonPrimaryUrl , buttonPrimaryIcon , buttonPrimaryBorderShadow , buttonPrimaryNewTab , buttonPrimaryBg , buttonSecondaryText , buttonSecondaryUrl , buttonSecondaryIcon , buttonSecondaryNewTab , signaturePopupOpen  } = param;
    var _context_globalData, _context_globalData_utmData;
    const context = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_components_AppContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
    const [signaturePopup, setSignaturePopup] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        open: false,
        mode: "register"
    });
    const [is1DollarTrialCampaignState, setIs1DollarTrialCampaignState] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const isSignaturePage = signaturePopupOpen;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        var _context_globalData, _context_globalData_utmData;
        setIs1DollarTrialCampaignState((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__/* .is1DollarTrialCampaign */ .Og)({
            utm_campaign: context === null || context === void 0 ? void 0 : (_context_globalData = context.globalData) === null || _context_globalData === void 0 ? void 0 : (_context_globalData_utmData = _context_globalData.utmData) === null || _context_globalData_utmData === void 0 ? void 0 : _context_globalData_utmData.utm_campaign
        }));
    }, [
        context === null || context === void 0 ? void 0 : (_context_globalData = context.globalData) === null || _context_globalData === void 0 ? void 0 : (_context_globalData_utmData = _context_globalData.utmData) === null || _context_globalData_utmData === void 0 ? void 0 : _context_globalData_utmData.utm_campaign
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col gap-7 sm:gap-8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SignatureRegister__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                isPopupOpen: signaturePopup.open && isSignaturePage,
                mode: signaturePopup.mode,
                setIsPopupOpen: (value)=>setSignaturePopup((prev)=>({
                            ...prev,
                            open: value
                        })),
                setMode: (mode)=>setSignaturePopup((prev)=>({
                            ...prev,
                            mode: mode
                        }))
            }),
            heading1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "font-bold text-4xl sm:text-5xl lg:text-6xl mxl:text-7xl",
                children: heading1
            }),
            heading2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "font-bold leading-[45px] sm:leading-[55px] lg:leading-tight text-[36px] sm:text-[48px] lg:text-5xl",
                children: heading2
            }),
            heading3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "font-bold text-2xl sm:text-3xl",
                children: heading3
            }),
            paragraph && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-lg sm:text-xl ".concat(paragraphStyling),
                children: paragraph
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-2 flex items-center flex-wrap gap-4 sm:gap-6 ".concat(buttonsStyling && buttonsStyling),
                children: [
                    buttonPrimaryText && (isSignaturePage ? is1DollarTrialCampaignState ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_google_ads_Buttons__WEBPACK_IMPORTED_MODULE_6__/* .Button1 */ .g, {
                        btnText: buttonPrimaryText,
                        bgColor: buttonPrimaryBg || "bg-violet-500",
                        textColor: "text-white",
                        border: "border border-violet-500 ",
                        showLoading: false,
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__/* .HiArrowLongRight */ .P8b, {}),
                        borderShadow: buttonPrimaryBorderShadow !== null && buttonPrimaryBorderShadow !== void 0 ? buttonPrimaryBorderShadow : true,
                        px: "px-5"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Buttons__WEBPACK_IMPORTED_MODULE_3__/* .ButtonPrimaryDiv */ .gf, {
                        buttonText: buttonPrimaryText,
                        onclick: ()=>setSignaturePopup((prev)=>({
                                    ...prev,
                                    open: true
                                })),
                        buttonUrl: buttonPrimaryUrl,
                        icon: buttonPrimaryIcon,
                        borderShadow: buttonPrimaryBorderShadow,
                        newTab: buttonPrimaryNewTab,
                        bgColor: buttonPrimaryBg
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__/* .CLMButtonPrimary */ .IS, {
                        buttonText: buttonPrimaryText,
                        buttonUrl: buttonPrimaryUrl,
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__/* .HiArrowLongRight */ .P8b, {})
                    })),
                    buttonSecondaryText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__/* .CLMButtonSecondaryBorder */ .AL, {
                        buttonText: buttonSecondaryText,
                        buttonUrl: buttonSecondaryUrl
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CtaOne);


/***/ }),

/***/ 8131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43138);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56475);
/* harmony import */ var _components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59183);









const comparisonsData = [
    {
        id: 1,
        title: "DocuSign alternatives",
        description: "Explore top alternatives to the popular eSignature solution, DocuSign.",
        image: "/thumbnail1.png",
        localImage: "/thumbnail1.png",
        link: "/docusign-alternatives",
        bgColor: "bg-rose-100/75"
    },
    {
        title: "DocuSign vs BoloSign",
        description: "Comparison of DocuSign and BoloSign for electronic signatures.",
        image: "/thumbnail2.png",
        localImage: "/thumbnail2.png",
        link: "/docusign-vs-bolosign",
        bgColor: "bg-green-100/75"
    },
    {
        title: "BoloSign vs Adobe Sign",
        description: "BoloSign and Adobe Sign feature and pricing comparison.",
        image: "/thumbnail6.png",
        localImage: "/thumbnail6.png",
        link: "/bolosign-vs-adobe-sign",
        bgColor: "bg-yellow-100/75"
    },
    {
        title: "BoloSign vs Dropbox Sign",
        description: "Evaluating BoloSign versus Dropbox Sign for digital signing.",
        image: "/thumbnail7.png",
        localImage: "/thumbnail7.png",
        link: "/bolosign-vs-dropbox-sign",
        bgColor: "bg-lime-100/75"
    },
    {
        title: "BoloSign vs HelloSign",
        description: "BoloSign and HelloSign comparison for electronic document signing.",
        image: "/thumbnail5.png",
        localImage: "/thumbnail5.png",
        link: "/bolosign-vs-hellosign",
        bgColor: "bg-orange-100/75"
    },
    {
        title: "BoloSign vs Pandadoc",
        description: "BoloSign and Pandadoc comparison for contract management solutions.",
        image: "/thumbnail3.png",
        localImage: "/thumbnail3.png",
        link: "/bolosign-vs-pandadoc",
        bgColor: "bg-green-100/75"
    },
    {
        title: "BoloSign vs Signeasy",
        description: "Compare BoloSign and Signeasy for simple document signing.",
        image: "/thumbnail8.png",
        localImage: "/thumbnail8.png",
        link: "/bolosign-vs-signeasy",
        bgColor: "bg-yellow-100/75"
    },
    {
        title: "BoloSign vs Signwell",
        description: "Detailed comparison between BoloSign and Signwell for signatures.",
        image: "/thumbnail4.png",
        localImage: "/thumbnail4.png",
        link: "/bolosign-vs-signwell",
        bgColor: "bg-rose-100/75"
    },
    {
        title: "BoloSign vs Zoho Sign",
        description: "Compare BoloSign and Zoho Sign for business use.",
        image: "/thumbnail9.png",
        localImage: "/thumbnail9.png",
        link: "/bolosign-vs-zoho-sign",
        bgColor: "bg-lime-100/75"
    },
    {
        id: 2,
        title: "DocuSign vs Zoho Sign",
        description: "E-Signature Showdown: DocuSign vs. Zoho Sign - Making the Right Choice for Your Business",
        image: "/thumbnail15.png",
        localImage: "/thumbnail15.png",
        link: "/docusign-vs-zoho-sign",
        bgColor: "bg-green-100/75"
    },
    {
        id: 3,
        title: "DocuSign vs SignWell",
        description: "DocuSign or SignWell: Which E-Signature Solution Is Right for Your Business?",
        image: "/thumbnail13.png",
        localImage: "/thumbnail13.png",
        link: "/docusign-vs-signwell",
        bgColor: "bg-yellow-100/75"
    },
    {
        id: 4,
        title: "DocuSign vs Pandadoc",
        description: "Selecting the Ideal eSignature Solution for Small Businesses: DocuSign vs. PandaDoc Comparison",
        image: "/thumbnail10.png",
        localImage: "/thumbnail10.png",
        link: "/docusign-vs-pandadoc",
        bgColor: "bg-lime-100/75"
    },
    {
        id: 5,
        title: "DocuSign vs Signeasy",
        description: "Signeasy offers an alternative e-signature solution with a focus on simplicity and ease of use.",
        image: "/thumbnail14.png",
        localImage: "/thumbnail14.png",
        link: "/docusign-vs-signeasy",
        bgColor: "bg-orange-100/75"
    },
    {
        id: 6,
        title: "DocuSign vs Adobe Sign",
        description: "Comparing DocuSign and Adobe Sign for Small Businesses: A Comprehensive Analysis.",
        image: "/thumbnail21.png",
        localImage: "/thumbnail21.png",
        link: "/docusign-vs-adobe-sign",
        bgColor: "bg-green-100/75"
    },
    {
        id: 7,
        title: "Adobe Sign vs SignWell",
        description: "Adobe Sign vs. SignWell: Which E-Signature Tool Should You Choose?",
        image: "/thumbnail18.png",
        localImage: "/thumbnail18.png",
        link: "/adobe-sign-vs-signwell",
        bgColor: "bg-yellow-100/75"
    },
    {
        id: 8,
        title: "Adobe Sign vs PandaDoc",
        description: "Adobe Sign vs. PandaDoc: Finding the Perfect Fit for Your Business.",
        image: "/thumbnail19.png",
        localImage: "/thumbnail19.png",
        link: "/adobe-sign-vs-pandadoc",
        bgColor: "bg-gray-100/75"
    },
    {
        id: 9,
        title: "Adobe Sign vs Zoho Sign",
        description: "Adobe Sign vs. Zoho Sign - Picking the Perfect E-Signature Partner For Your Business",
        image: "/thumbnail16.png",
        localImage: "/thumbnail16.png",
        link: "/adobe-sign-vs-zoho-sign",
        bgColor: "bg-rose-100/75"
    },
    {
        id: 10,
        title: "Adobe Sign vs Dropbox Sign",
        description: "Navigating the Digital Revolution: Adobe Sign vs. Dropbox Sign - Choosing Your Electronic Signature Solution",
        image: "/thumbnail20.png",
        localImage: "/thumbnail20.png",
        link: "/adobe-sign-vs-dropbox-sign",
        bgColor: "bg-cyan-100/75"
    },
    {
        id: 11,
        title: "Adobe Acrobat Sign vs Signeasy",
        description: "Adobe Acrobat Sign vs. SignEasy: Choosing the Right E-Signature Solution For Your Small Business.",
        image: "/thumbnail17.png",
        localImage: "/thumbnail17.png",
        link: "/adobe-acrobat-sign-vs-signeasy",
        bgColor: "bg-gray-100/75"
    },
    {
        id: 12,
        title: "Dropbox Sign vs DocuSign",
        description: "A Comprehensive Comparison of Dropbox Sign and DocuSign: Which E-Signature Solution Fits Your Needs?",
        image: "/thumbnail11.png",
        localImage: "/thumbnail11.png",
        link: "/dropbox-sign-vs-docusign",
        bgColor: "bg-yellow-100/75"
    }
];
const Alternatives = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "mt-8 md:mt-20",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Signature Comparisons & Alternatives | BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Explore our comprehensive comparisons and alternatives to various eSignature solutions. Make an informed decision that best suits your business needs."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.region",
                        content: "IN"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.position",
                        content: "22.351115;78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "ICBM",
                        content: "22.351115, 78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "author",
                        content: "Boloforms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "publisher",
                        content: "BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "esignature comparisons, esignature alternatives,e-signature comparisons, e-signature alternatives, adobe acrobat sign, signeasy, adobe acrobat sign vs signeasy, adobe acrobat sign vs signeasy comparison, adobe acrobat sign vs signeasy alternatives, adobe acrobat sign vs signeasy pricing, adobe acrobat sign vs signeasy features, adobe acrobat sign vs signeasy review, adobe acrobat sign vs signeasy pros and cons, adobe acrobat sign vs signeasy cons and pros, adobe acrobat sign vs signeasy comparison in india, adobe acrobat sign vs signeasy comparison in usa, adobe acrobat sign vs dropbox sign, adobe acrobat sign vs dropbox sign comparison, adobe acrobat sign vs dropbox sign alternatives, adobe acrobat sign vs dropbox sign pricing, adobe acrobat sign vs dropbox sign features, adobe acrobat sign vs dropbox sign review, adobe acrobat sign vs dropbox sign pros and cons, adobe acrobat sign vs dropbox sign cons and pros, adobe acrobat sign vs dropbox sign comparison in india, adobe acrobat sign vs dropbox sign comparison in usa, adobe sign vs pandadoc, adobe sign vs pandadoc comparison, adobe sign vs pandadoc alternatives, adobe sign vs pandadoc pricing, adobe sign vs pandadoc features, adobe sign vs pandadoc review, adobe sign vs pandadoc pros and cons, adobe sign vs pandadoc cons and pros, adobe sign vs pandadoc comparison in india, adobe sign vs pandadoc comparison in usa, adobe sign vs zoho sign, adobe sign vs zoho sign comparison, adobe sign vs zoho sign alternatives, adobe sign vs zoho sign pricing, adobe sign vs zoho sign features, adobe sign vs zoho sign review, adobe sign vs zoho sign pros and cons, adobe sign vs zoho sign cons and pros, adobe sign vs zoho sign comparison in india, adobe sign vs zoho sign comparison in usa, adobe sign vs docusign, adobe sign vs docusign comparison, adobe sign vs docusign alternatives, adobe sign vs docusign pricing, adobe sign vs docusign features, adobe sign vs docusign review, adobe sign vs docusign pros and cons, adobe sign vs docusign cons and pros, adobe sign vs docusign comparison in india, adobe sign vs docusign comparison in usa, adobe sign vs dropbox sign, adobe sign vs dropbox sign comparison, adobe sign vs dropbox sign alternatives, adobe sign vs dropbox sign pricing, adobe sign vs dropbox sign features, adobe sign vs dropbox sign review, adobe sign vs dropbox sign pros and cons, adobe sign vs dropbox sign cons and pros, adobe sign vs dropbox sign comparison in india, adobe sign vs dropbox sign comparison in usa, adobe acrobat sign vs signeasy, adobe acrobat sign vs signeasy comparison, adobe acrobat sign vs signeasy alternatives, adobe acrobat sign vs signeasy pricing, adobe acrobat sign vs signeasy features, adobe acrobat sign vs signeasy review, adobe acrobat sign vs signeasy pros and cons, adobe acrobat sign vs signeasy cons and pros, adobe acrobat sign vs signeasy comparison in india, adobe acrobat sign vs signeasy comparison in usa, adobe acrobat sign vs docusign, docusign alternatives, docusign vs zoho sign, docusign vs signwell, docusign vs pandadoc, docusign vs signeasy, docusign vs adobe sign, adobe sign vs signwell, adobe sign vs pandadoc, adobe sign vs zoho sign, adobe sign vs dropbox sign, adobe acrobat sign vs signeasy, adobe acrobat sign vs dropbox sign, dropbox sign vs docusign, dropbox sign vs adobe sign, dropbox sign vs signeasy, dropbox sign vs pandadoc, dropbox sign vs zoho sign, dropbox sign vs signwell, dropbox sign vs adobe, signature, e-signature, e-signature solution, e-signature software, e-signature app, e-signature tool, e-signature platform, e-signature service"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/signature/alternatives/"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "Signature Comparisons & Alternatives | BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://www.bolosign.com/signature/alternatives/"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "Signature Comparisons & Alternatives | BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@boloforms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:domain",
                        content: "https://bolosign.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/signature/alternatives/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mx-auto max-w-[1000px] text-center md:px-8 px-4",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            heading1: "Comparisons & Alternatives",
                            paragraph: " Explore our comprehensive comparisons andalternatives to various eSignature solutions. Make an informed decision that best suits your            business needs."
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-gray-600 body-font md:px-8 px-4 max-w-screen-xl mx-auto",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full max-w-screen-mxl py-20 sm:py-24 mx-auto",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "grid grid-cols-1 sm:grid-cols-2 xlg:grid-cols-3 gap-8",
                                children: comparisonsData.map((card, index)=>{
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        className: " h-full rounded-3xl transition-all duration-500 ease-in-out border border-surface-dark group hover:bg-surface bg-white  overflow-hidden cursor-pointer",
                                        href: "/signature/alternatives".concat(card.link),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "rounded-t-lg h-[230px] sm:h-[270px] ",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                    alt: "content",
                                                    className: "w-full h-full object-cover",
                                                    src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_5__.BASE_ASSETS_URL, "/v2/alternatives").concat(card.image),
                                                    width: 10,
                                                    height: 10
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "px-4 sm:px-6 py-6 sm:py-8 flex justify-between flex-col h-fit sm:h-64 gap-6 sm:gap-3 w-full",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "w-full",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                                className: "text-2xl font-semibold title-font text-black",
                                                                children: card.title
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "text-base leading-relaxed text-gray-900",
                                                                children: card.description
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "w-full flex justify-start items-center",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_6__/* .CLMLinkPrimaryArrow */ .c$, {
                                                            buttonText: "View Article",
                                                            buttonUrl: "/signature/alternatives".concat(card.link)
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Alternatives);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(62454); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);